export default __webpack_public_path__ + "919d19f5c87e4d4f5c80732b0effba1f.png";